import * as api from '../api/queuesetting';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

const namespace = 'QUEUE';

export const FETCH_QUEUES = createRequestTypes(`${namespace}/FETCH_QUEUES`);

export const fetchQueues = makeApiActionCreatorV3(
  api.fetchQueues,
  FETCH_QUEUES[START],
  FETCH_QUEUES[SUCCESS],
  FETCH_QUEUES[ERROR],
);

export const ADD_QUEUE = createRequestTypes(`${namespace}/ADD_QUEUE`);

export const addQueue = makeApiActionCreatorV3(
  api.addQueue,
  ADD_QUEUE[START],
  ADD_QUEUE[SUCCESS],
  ADD_QUEUE[ERROR],
);

export const FETCH_QUEUE = createRequestTypes(`${namespace}/FETCH_QUEUE`);

export const fetchQueue = makeApiActionCreatorV3(
  api.fetchQueue,
  FETCH_QUEUE[START],
  FETCH_QUEUE[SUCCESS],
  FETCH_QUEUE[ERROR],
);

export const DELETE_QUEUE = createRequestTypes(`${namespace}/DELETE_QUEUE`);

export const deleteQueue = makeApiActionCreatorV3(
  api.deleteQueue,
  DELETE_QUEUE[START],
  DELETE_QUEUE[SUCCESS],
  DELETE_QUEUE[ERROR],
);

export const UPDATE_QUEUE = createRequestTypes(`${namespace}/UPDATE_QUEUE`);

export const updateQueue = makeApiActionCreatorV3(
  api.updateQueue,
  UPDATE_QUEUE[START],
  UPDATE_QUEUE[SUCCESS],
  UPDATE_QUEUE[ERROR],
);

export const FETCH_QUEUE_USERS = createRequestTypes(
  `${namespace}/FETCH_QUEUE_USERS`,
);

export const fetchQueueUsers = makeApiActionCreatorV3(
  api.fetchQueueUsers,
  FETCH_QUEUE_USERS[START],
  FETCH_QUEUE_USERS[SUCCESS],
  FETCH_QUEUE_USERS[ERROR],
);

export const ADD_QUEUE_USER = createRequestTypes(`${namespace}/ADD_QUEUE_USER`);

export const addQueueUser = makeApiActionCreatorV3(
  api.addQueueUser,
  ADD_QUEUE_USER[START],
  ADD_QUEUE_USER[SUCCESS],
  ADD_QUEUE_USER[ERROR],
);

export const FETCH_QUEUE_USER = createRequestTypes(
  `${namespace}/FETCH_QUEUE_USER`,
);

export const fetchQueueUser = makeApiActionCreatorV3(
  api.fetchQueueUser,
  FETCH_QUEUE_USER[START],
  FETCH_QUEUE_USER[SUCCESS],
  FETCH_QUEUE_USER[ERROR],
);

export const DELETE_QUEUE_USER = createRequestTypes(
  `${namespace}/DELETE_QUEUE_USER`,
);

export const deleteQueueUser = makeApiActionCreatorV3(
  api.deleteQueueUser,
  DELETE_QUEUE_USER[START],
  DELETE_QUEUE_USER[SUCCESS],
  DELETE_QUEUE_USER[ERROR],
);

export const UPDATE_QUEUE_USER = createRequestTypes(
  `${namespace}/UPDATE_QUEUE_USER`,
);

export const updateQueueUser = makeApiActionCreatorV3(
  api.updateQueueUser,
  UPDATE_QUEUE_USER[START],
  UPDATE_QUEUE_USER[SUCCESS],
  UPDATE_QUEUE_USER[ERROR],
);

export const FETCH_ALL_USERS = createRequestTypes(
  `${namespace}/FETCH_ALL_USERS`,
);

export const fetchAllUsers = makeApiActionCreatorV3(
  api.fetchAllUsers,
  FETCH_ALL_USERS[START],
  FETCH_ALL_USERS[SUCCESS],
  FETCH_ALL_USERS[ERROR],
);

export const FETCH_QUEUE_WORK_ITEMS = createRequestTypes(
  `${namespace}/FETCH_QUEUE_WORK_ITEMS`,
);

export const fetchQueueWorkItems = makeApiActionCreatorV3(
  api.fetchQueueWorkItems,
  FETCH_QUEUE_WORK_ITEMS[START],
  FETCH_QUEUE_WORK_ITEMS[SUCCESS],
  FETCH_QUEUE_WORK_ITEMS[ERROR],
);

export const FETCH_QUEUE_FIRST_WORK_ITEM = createRequestTypes(
  `${namespace}/FETCH_QUEUE_FIRST_WORK_ITEM`,
);

export const fetchQueueFirstWorkItem = makeApiActionCreatorV3(
  api.fetchQueueFirstWorkItem,
  FETCH_QUEUE_FIRST_WORK_ITEM[START],
  FETCH_QUEUE_FIRST_WORK_ITEM[SUCCESS],
  FETCH_QUEUE_FIRST_WORK_ITEM[ERROR],
);

export const FETCH_QUEUE_WORK_ITEM = createRequestTypes(
  `${namespace}/FETCH_QUEUE_WORK_ITEM`,
);

export const fetchQueueWorkItem = makeApiActionCreatorV3(
  api.fetchQueueWorkItem,
  FETCH_QUEUE_WORK_ITEM[START],
  FETCH_QUEUE_WORK_ITEM[SUCCESS],
  FETCH_QUEUE_WORK_ITEM[ERROR],
);

export const UPDATE_QUEUE_WORK_ITEM = createRequestTypes(
  `${namespace}/UPDATE_QUEUE_WORK_ITEM`,
);

export const updateQueueWorkItem = makeApiActionCreatorV3(
  api.updateQueueWorkItem,
  UPDATE_QUEUE_WORK_ITEM[START],
  UPDATE_QUEUE_WORK_ITEM[SUCCESS],
  UPDATE_QUEUE_WORK_ITEM[ERROR],
);

export const FETCH_WORK_ITEM_ATTACHMENTS = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_ATTACHMENTS`,
);

export const fetchWorkItemAttachments = makeApiActionCreatorV3(
  api.fetchWorkItemAttachments,
  FETCH_WORK_ITEM_ATTACHMENTS[START],
  FETCH_WORK_ITEM_ATTACHMENTS[SUCCESS],
  FETCH_WORK_ITEM_ATTACHMENTS[ERROR],
);

export const ADD_WORK_ITEM_ATTACHMENT = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_ATTACHMENT`,
);

export const addWorkItemAttachment = makeApiActionCreatorV3(
  api.addWorkItemAttachment,
  ADD_WORK_ITEM_ATTACHMENT[START],
  ADD_WORK_ITEM_ATTACHMENT[SUCCESS],
  ADD_WORK_ITEM_ATTACHMENT[ERROR],
);

export const DOWNLOAD_WORK_ITEM_ATTACHMENT = createRequestTypes(
  `${namespace}/DOWNLOAD_WORK_ITEM_ATTACHMENT`,
);

export const downloadWorkItemAttachment = makeApiActionCreatorV3(
  api.downloadWorkItemAttachment,
  DOWNLOAD_WORK_ITEM_ATTACHMENT[START],
  DOWNLOAD_WORK_ITEM_ATTACHMENT[SUCCESS],
  DOWNLOAD_WORK_ITEM_ATTACHMENT[ERROR],
);

export const DELETE_WORK_ITEM_ATTACHMENT = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_ATTACHMENT`,
);

export const deleteWorkItemAttachment = makeApiActionCreatorV3(
  api.deleteWorkItemAttachment,
  DELETE_WORK_ITEM_ATTACHMENT[START],
  DELETE_WORK_ITEM_ATTACHMENT[SUCCESS],
  DELETE_WORK_ITEM_ATTACHMENT[ERROR],
);

export const FETCH_WORK_ITEM_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_PROPERTIES`,
);

export const fetchWorkItemProperties = makeApiActionCreatorV3(
  api.fetchWorkItemProperties,
  FETCH_WORK_ITEM_PROPERTIES[START],
  FETCH_WORK_ITEM_PROPERTIES[SUCCESS],
  FETCH_WORK_ITEM_PROPERTIES[ERROR],
);

export const ADD_WORK_ITEM_PROPERTY = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_PROPERTY`,
);

export const addWorkItemProperty = makeApiActionCreatorV3(
  api.addWorkItemProperty,
  ADD_WORK_ITEM_PROPERTY[START],
  ADD_WORK_ITEM_PROPERTY[SUCCESS],
  ADD_WORK_ITEM_PROPERTY[ERROR],
);

export const DELETE_WORK_ITEM_PROPERTY = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_PROPERTY`,
);

export const deleteWorkItemProperty = makeApiActionCreatorV3(
  api.deleteWorkItemProperty,
  DELETE_WORK_ITEM_PROPERTY[START],
  DELETE_WORK_ITEM_PROPERTY[SUCCESS],
  DELETE_WORK_ITEM_PROPERTY[ERROR],
);

export const FETCH_WORK_ITEM_APPEALS = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_APPEALS`,
);

export const fetchWorkItemAppeals = makeApiActionCreatorV3(
  api.fetchWorkItemAppeals,
  FETCH_WORK_ITEM_APPEALS[START],
  FETCH_WORK_ITEM_APPEALS[SUCCESS],
  FETCH_WORK_ITEM_APPEALS[ERROR],
);

export const ADD_WORK_ITEM_APPEAL = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_APPEAL`,
);

export const addWorkItemAppeal = makeApiActionCreatorV3(
  api.addWorkItemAppeal,
  ADD_WORK_ITEM_APPEAL[START],
  ADD_WORK_ITEM_APPEAL[SUCCESS],
  ADD_WORK_ITEM_APPEAL[ERROR],
);

export const DELETE_WORK_ITEM_APPEAL = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_APPEAL`,
);

export const deleteWorkItemAppeal = makeApiActionCreatorV3(
  api.deleteWorkItemAppeal,
  DELETE_WORK_ITEM_APPEAL[START],
  DELETE_WORK_ITEM_APPEAL[SUCCESS],
  DELETE_WORK_ITEM_APPEAL[ERROR],
);

export const FETCH_WORK_ITEM_DEEDS = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_DEEDS`,
);

export const fetchWorkItemDeeds = makeApiActionCreatorV3(
  api.fetchWorkItemDeeds,
  FETCH_WORK_ITEM_DEEDS[START],
  FETCH_WORK_ITEM_DEEDS[SUCCESS],
  FETCH_WORK_ITEM_DEEDS[ERROR],
);

export const ADD_WORK_ITEM_DEED = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_DEED`,
);

export const addWorkItemDeed = makeApiActionCreatorV3(
  api.addWorkItemDeed,
  ADD_WORK_ITEM_DEED[START],
  ADD_WORK_ITEM_DEED[SUCCESS],
  ADD_WORK_ITEM_DEED[ERROR],
);

export const DELETE_WORK_ITEM_DEED = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_DEED`,
);

export const deleteWorkItemDeed = makeApiActionCreatorV3(
  api.deleteWorkItemDeed,
  DELETE_WORK_ITEM_DEED[START],
  DELETE_WORK_ITEM_DEED[SUCCESS],
  DELETE_WORK_ITEM_DEED[ERROR],
);

export const FETCH_WORK_ITEM_EVENTS = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_EVENTS`,
);

export const fetchWorkItemEvents = makeApiActionCreatorV3(
  api.fetchWorkItemEvents,
  FETCH_WORK_ITEM_EVENTS[START],
  FETCH_WORK_ITEM_EVENTS[SUCCESS],
  FETCH_WORK_ITEM_EVENTS[ERROR],
);

export const ADD_WORK_ITEM_EVENT = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_EVENT`,
);

export const addWorkItemEvent = makeApiActionCreatorV3(
  api.addWorkItemEvent,
  ADD_WORK_ITEM_EVENT[START],
  ADD_WORK_ITEM_EVENT[SUCCESS],
  ADD_WORK_ITEM_EVENT[ERROR],
);

export const DELETE_WORK_ITEM_EVENT = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_EVENT`,
);

export const deleteWorkItemEvent = makeApiActionCreatorV3(
  api.deleteWorkItemEvent,
  DELETE_WORK_ITEM_EVENT[START],
  DELETE_WORK_ITEM_EVENT[SUCCESS],
  DELETE_WORK_ITEM_EVENT[ERROR],
);

export const FETCH_WORK_ITEM_BUILDING_PERMITS = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_BUILDING_PERMITS`,
);

export const fetchWorkItemBuildingPermits = makeApiActionCreatorV3(
  api.fetchWorkItemBuildingPermits,
  FETCH_WORK_ITEM_BUILDING_PERMITS[START],
  FETCH_WORK_ITEM_BUILDING_PERMITS[SUCCESS],
  FETCH_WORK_ITEM_BUILDING_PERMITS[ERROR],
);

export const ADD_WORK_ITEM_BUILDING_PERMIT = createRequestTypes(
  `${namespace}/ADD_WORK_ITEM_BUILDING_PERMIT`,
);

export const addWorkItemBuildingPermit = makeApiActionCreatorV3(
  api.addWorkItemBuildingPermit,
  ADD_WORK_ITEM_BUILDING_PERMIT[START],
  ADD_WORK_ITEM_BUILDING_PERMIT[SUCCESS],
  ADD_WORK_ITEM_BUILDING_PERMIT[ERROR],
);

export const DELETE_WORK_ITEM_BUILDING_PERMIT = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_BUILDING_PERMIT`,
);

export const deleteWorkItemBuildingPermit = makeApiActionCreatorV3(
  api.deleteWorkItemBuildingPermit,
  DELETE_WORK_ITEM_BUILDING_PERMIT[START],
  DELETE_WORK_ITEM_BUILDING_PERMIT[SUCCESS],
  DELETE_WORK_ITEM_BUILDING_PERMIT[ERROR],
);

export const CHANGE_WORK_ITEM_ORDER = createRequestTypes(
  `${namespace}/CHANGE_WORK_ITEM_ORDER`,
);

export const changeWorkItemOrder = makeApiActionCreatorV3(
  api.changeWorkItemOrder,
  CHANGE_WORK_ITEM_ORDER[START],
  CHANGE_WORK_ITEM_ORDER[SUCCESS],
  CHANGE_WORK_ITEM_ORDER[ERROR],
);

export const MOVE_WORK_ITEMS = createRequestTypes(
  `${namespace}/MOVE_WORK_ITEMS`,
);

export const moveWorkItems = makeApiActionCreatorV3(
  api.moveWorkItems,
  MOVE_WORK_ITEMS[START],
  MOVE_WORK_ITEMS[SUCCESS],
  MOVE_WORK_ITEMS[ERROR],
);

export const FINALIZE_WORK_ITEM = createRequestTypes(
  `${namespace}/FINALIZE_WORK_ITEM`,
);

export const finalizeWorkItem = makeApiActionCreatorV3(
  api.finalizeWorkItem,
  FINALIZE_WORK_ITEM[START],
  FINALIZE_WORK_ITEM[SUCCESS],
  FINALIZE_WORK_ITEM[ERROR],
);

export const REOPEN_WORK_ITEM = createRequestTypes(
  `${namespace}/REOPEN_WORK_ITEM`,
);

export const reopenWorkItem = makeApiActionCreatorV3(
  api.reopenWorkItem,
  REOPEN_WORK_ITEM[START],
  REOPEN_WORK_ITEM[SUCCESS],
  REOPEN_WORK_ITEM[ERROR],
);

export const FETCH_QUEUE_STATISTICS = createRequestTypes(
  `${namespace}/FETCH_QUEUE_STATISTICS`,
);

export const fetchQueueStatistics = makeApiActionCreatorV3(
  api.fetchQueueStatistics,
  FETCH_QUEUE_STATISTICS[START],
  FETCH_QUEUE_STATISTICS[SUCCESS],
  FETCH_QUEUE_STATISTICS[ERROR],
);

export const FETCH_QUEUE_HISTORIES = createRequestTypes(
  `${namespace}/FETCH_QUEUE_HISTORIES`,
);

export const fetchQueueHistories = makeApiActionCreatorV3(
  api.fetchQueueHistories,
  FETCH_QUEUE_HISTORIES[START],
  FETCH_QUEUE_HISTORIES[SUCCESS],
  FETCH_QUEUE_HISTORIES[ERROR],
);

export const FETCH_STATUS_HISTORIES = createRequestTypes(
  `${namespace}/FETCH_STATUS_HISTORIES`,
);

export const fetchStatusHistories = makeApiActionCreatorV3(
  api.fetchStatusHistories,
  FETCH_STATUS_HISTORIES[START],
  FETCH_STATUS_HISTORIES[SUCCESS],
  FETCH_STATUS_HISTORIES[ERROR],
);

export const SHARE_VIRTUAL_ROOM = createRequestTypes(
  `${namespace}/SHARE_VIRTUAL_ROOM`,
);

export const shareVirtualRoom = makeApiActionCreatorV3(
  api.shareVirtualRoom,
  SHARE_VIRTUAL_ROOM[START],
  SHARE_VIRTUAL_ROOM[SUCCESS],
  SHARE_VIRTUAL_ROOM[ERROR],
);

export const MASS_UPDATE_STATUS = createRequestTypes(
  `${namespace}/MASS_UPDATE_STATUS`,
);

export const massUpdateStatus = makeApiActionCreatorV3(
  api.massUpdateStatus,
  MASS_UPDATE_STATUS[START],
  MASS_UPDATE_STATUS[SUCCESS],
  MASS_UPDATE_STATUS[ERROR],
);

export const CHECK_WORK_ITEM_EDITABLE = createRequestTypes(
  `${namespace}/CHECK_WORK_ITEM_EDITABLE`,
);

export const checkWorkItemEditable = makeApiActionCreatorV3(
  api.checkWorkItemEditable,
  CHECK_WORK_ITEM_EDITABLE[START],
  CHECK_WORK_ITEM_EDITABLE[SUCCESS],
  CHECK_WORK_ITEM_EDITABLE[ERROR],
);

export const INSERT_WORK_ITEM_NOTES = createRequestTypes(
  `${namespace}/INSERT_WORK_ITEM_NOTES`,
);

export const insertWorkItemNotes = makeApiActionCreatorV3(
  api.insertWorkItemNotes,
  INSERT_WORK_ITEM_NOTES[START],
  INSERT_WORK_ITEM_NOTES[SUCCESS],
  INSERT_WORK_ITEM_NOTES[ERROR],
);

export const FETCH_WORK_ITEM_NOTES = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_NOTES`,
);

export const fetchWorkItemNotes = makeApiActionCreatorV3(
  api.fetchWorkItemNotes,
  FETCH_WORK_ITEM_NOTES[START],
  FETCH_WORK_ITEM_NOTES[SUCCESS],
  FETCH_WORK_ITEM_NOTES[ERROR],
);

export const FETCH_WORK_ITEM_NOTE = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_NOTE`,
);

export const fetchWorkItemNote = makeApiActionCreatorV3(
  api.fetchWorkItemNote,
  FETCH_WORK_ITEM_NOTE[START],
  FETCH_WORK_ITEM_NOTE[SUCCESS],
  FETCH_WORK_ITEM_NOTE[ERROR],
);

export const UPDATE_WORK_ITEM_NOTE = createRequestTypes(
  `${namespace}/UPDATE_WORK_ITEM_NOTE`,
);

export const updateWorkItemNote = makeApiActionCreatorV3(
  api.updateWorkItemNote,
  UPDATE_WORK_ITEM_NOTE[START],
  UPDATE_WORK_ITEM_NOTE[SUCCESS],
  UPDATE_WORK_ITEM_NOTE[ERROR],
);

export const DELETE_WORK_ITEM_NOTE = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEM_NOTE`,
);

export const deleteWorkItemNote = makeApiActionCreatorV3(
  api.deleteWorkItemNote,
  DELETE_WORK_ITEM_NOTE[START],
  DELETE_WORK_ITEM_NOTE[SUCCESS],
  DELETE_WORK_ITEM_NOTE[ERROR],
);

export const SET_BACK_WORK_ITEM = 'QUEUE/SET_BACK_WORK_ITEM';

export function setBackWorkItem({ workItemID, fromSearchType }) {
  return async dispatch => {
    dispatch({
      type: SET_BACK_WORK_ITEM,
      data: {
        workItemID,
        fromSearchType,
      },
    });
  };
}

export const CHANGE_QUEUE_WORK_ITEMS_SORT_MODEL = 'QUEUE/CHANGE_QUEUE_WORK_ITEM_SORT_MODEL';

export const changeWorkItemsSortModel = sortModel => ({
  type: CHANGE_QUEUE_WORK_ITEMS_SORT_MODEL,
  payload: sortModel,
});

export const FETCH_COPY_FINALIZED_WORK_ITEM_RUNS = createRequestTypes(
  `${namespace}/FETCH_COPY_FINALIZED_WORK_ITEM_RUNS`,
);

export const fetchCopyFinalizedWorkItemRuns = makeApiActionCreatorV3(
  api.fetchCopyFinalizedWorkItemRuns,
  FETCH_COPY_FINALIZED_WORK_ITEM_RUNS[START],
  FETCH_COPY_FINALIZED_WORK_ITEM_RUNS[SUCCESS],
  FETCH_COPY_FINALIZED_WORK_ITEM_RUNS[ERROR],
);

export const FETCH_COPY_FINALIZED_WORK_ITEM_RUN_WORK_ITEMS = createRequestTypes(
  `${namespace}/FETCH_COPY_FINALIZED_WORK_ITEM_RUN_WORK_ITEMS`,
);

export const fetchCopyFinalizedWorkItemRunWorkItems = makeApiActionCreatorV3(
  api.fetchCopyFinalizedWorkItemRunWorkItems,
  FETCH_COPY_FINALIZED_WORK_ITEM_RUN_WORK_ITEMS[START],
  FETCH_COPY_FINALIZED_WORK_ITEM_RUN_WORK_ITEMS[SUCCESS],
  FETCH_COPY_FINALIZED_WORK_ITEM_RUN_WORK_ITEMS[ERROR],
);

export const START_COPY_FINALIZED_WORK_ITEM_RUN = createRequestTypes(
  `${namespace}/START_COPY_FINALIZED_WORK_ITEM_RUN`,
);

export const startCopyFinalizedWorkItemRun = makeApiActionCreatorV3(
  api.startCopyFinalizedWorkItemRun,
  START_COPY_FINALIZED_WORK_ITEM_RUN[START],
  START_COPY_FINALIZED_WORK_ITEM_RUN[SUCCESS],
  START_COPY_FINALIZED_WORK_ITEM_RUN[ERROR],
);

export const CHANGE_RUNS_PAGE = `${namespace}/CHANGE_RUNS_PAGE`;

export const changeRunsPage = page => ({
  type: CHANGE_RUNS_PAGE,
  payload: page,
});

export const CHANGE_RUNS_ROWS_PER_PAGE = `${namespace}/CHANGE_RUNS_ROWS_PER_PAGE`;

export const changeRunsRowsPerPage = rowsPerPage => ({
  type: CHANGE_RUNS_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_RUN_LISTING_PAGE = `${namespace}/CHANGE_RUN_LISTING_PAGE`;

export const changeRunListingPage = page => ({
  type: CHANGE_RUN_LISTING_PAGE,
  payload: page,
});

export const CHANGE_RUN_LISTING_ROWS_PER_PAGE = `${namespace}/CHANGE_RUN_LISTING_ROWS_PER_PAGE`;

export const changeRunListingRowsPerPage = rowsPerPage => ({
  type: CHANGE_RUN_LISTING_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const SET_ATTACHMENT_DETAIL_WORKITEM = `${namespace}/SET_ATTACHMENT_DETAIL_WORKITEM`;

export const setAttachmentDetailWorkItem = (workItems, workItem) => ({
  type: SET_ATTACHMENT_DETAIL_WORKITEM,
  payload: {
    workItems,
    workItem
  },
});

export const CLEAR_ATTACHMENT_DETAIL_WORKITEM = `${namespace}/CLEAR_ATTACHMENT_DETAIL_WORKITEM`;

export const clearAttachmentDetailWorkItem = () => ({
  type: CLEAR_ATTACHMENT_DETAIL_WORKITEM,
  payload: {},
});